module.exports = __webpack_public_path__ + "static/media/FF_Sports_pour_Tous.ede0b1a0.jpg";